import React, { useMemo } from "react";
import { array, object, number } from "prop-types";

import ListItem from "../../ListItem/ListItem.jsx";

const propTypes = {
  results: array,
  focusRef: object,
  focusItem: number,
};

const FullGrid = (props) => {
  const { results, focusRef, focusItem } = props;

  const resultsGroup = useMemo(() => {
    const size = 4;

    return results.reduce((acc, curr, i, self) => {
      if (!(i % size)) {
        return [...acc, self.slice(i, i + size)];
      }
      return acc;
    }, []);
  }, [results]);

  if (!results || results.length < 1) {
    return null;
  }

  return (
    <section className="full-grid">
      {resultsGroup.map((group, i) => (
        <React.Fragment key={group[0].key}>
          <div className="full-grid__split">
            <div className="full-grid__col full-grid__col--left">
              <div className="full-grid__list-item">
                <ListItem
                  {...group[0]}
                  link={{ href: group[0].contentUrl }}
                  media={group[0].imageSrcWide}
                  sizes="670px"
                  focusRef={i * 4 + 1 === focusItem ? focusRef : null}
                />
              </div>
              {group[1] && (
                <div className="full-grid__list-item">
                  <ListItem
                    {...group[1]}
                    media={group[1].imageSrcWide}
                    sizes="670px"
                    link={{ href: group[1].contentUrl }}
                    focusRef={i * 4 + 2 === focusItem ? focusRef : null}
                  />
                </div>
              )}
            </div>
            <div className="full-grid__col full-grid__col--right">
              {group[2] && (
                <div className="full-grid__list-item">
                  <ListItem
                    {...group[2]}
                    link={{ href: group[2].contentUrl }}
                    media={group[2].imageSrcSquare}
                    sizes="820px"
                    focusRef={i * 4 + 3 === focusItem ? focusRef : null}
                  />
                </div>
              )}
            </div>
          </div>
          {group[3] && (
            <div className="full-grid__wide">
              <div className="full-grid__list-item">
                <ListItem
                  {...group[3]}
                  link={{ href: group[3].contentUrl }}
                  media={group[3].imageSrcWide}
                  sizes="670px"
                  focusRef={i * 4 + 4 === focusItem ? focusRef : null}
                />
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </section>
  );
};
FullGrid.propTypes = propTypes;
export default React.memo(FullGrid);
